import {NavLink} from "react-router-dom";
import {IconContext} from "react-icons";
import {FaArrowCircleLeft} from "react-icons/fa";
import { useEffect, useState } from "react";
import imageYohan from "../photo/imageYohan.jpg";

export const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);
  return (
    <main className="min-h-screen bg-[#0B0B0F] text-white">
      {/* Navigation */}
      <div className="fixed top-5 left-5 z-50">
        <IconContext.Provider value={{ size: "2em", className: "text-white hover:text-gray-400 transition-colors" }}>
          <NavLink to={"/"}>
            <FaArrowCircleLeft />
          </NavLink>
        </IconContext.Provider>
      </div>
      
      {/* Titre de la page en haut */}
      <div className="pt-12 pb-4 text-center">
        <h1 className={`text-4xl md:text-5xl font-bold text-white tracking-tight transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          YOHANVISION
        </h1>
        <div className={`w-24 h-1 bg-white mx-auto mt-4 mb-8 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}`}></div>
      </div>
      
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Partie supérieure - Titre et introduction */}
        <div className="text-center mb-12">
          <h2 className={`text-3xl md:text-4xl font-bold mb-6 transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>Yohan Carrière</h2>
          <p className={`text-gray-300 text-lg mb-4 transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>Photographe & Vidéographe</p>
          <p className={`text-center p-5 px-10 font-semibold text-xl text-gray-300 uppercase tracking-wider transition-all duration-1000 delay-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            Capturer l'essence du monde à travers la lentille d'un passionné de vie
          </p>
          <div className={`w-16 h-1 bg-gray-500 mx-auto my-6 transition-all duration-1000 delay-800 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}`}></div>
        </div>
        
        {/* Partie centrale - Photo et texte côte à côte */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-16">
          {/* Premier paragraphe à gauche de la photo (sur desktop) */}
          <div className="md:w-1/3 order-2 md:order-1">
            <p className={`text-gray-300 leading-relaxed transition-all duration-1000 delay-900 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              Je suis l'aîné de 3 enfants et je chemine dans ma croissance
              personnelle depuis un peu plus d'un an, explorant les profondeurs de
              mon être et les horizons infinis de mon potentiel. J'aime ce qui
              stimule tous mes sens, en particulier être immergé dans la nature.
            </p>
          </div>
          
          {/* Photo au centre */}
          <div className={`relative w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden shadow-xl border-4 border-gray-700 transition-all duration-1000 delay-500 order-1 md:order-2 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}>
            <img 
              src={imageYohan} 
              alt="Yohan Carrière" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-30"></div>
          </div>
          
          {/* Deuxième paragraphe à droite de la photo (sur desktop) */}
          <div className="md:w-1/3 order-3">
            <p className={`text-gray-300 leading-relaxed transition-all duration-1000 delay-900 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              Sportif passionné, bouger est essentiel à ma vie. Que ce soit sur la
              glace pour le hockey, sur le parcours de golf, en courant sur les
              sentiers, en m'entraînant au gym, en escaladant des parois
              rocheuses, ou en dévalant les pentes en ski.
            </p>
          </div>
        </div>
        
        {/* Partie inférieure - Texte sous la photo */}
        <div className="mb-16">
          <p className={`w-full md:w-3/4 lg:w-2/3 mx-auto text-center text-gray-300 leading-relaxed transition-all duration-1000 delay-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            À travers l'objectif de ma caméra, je capture non seulement des
            images, mais aussi des émotions, des aventures et la beauté pure de
            notre monde, pour permettre à chacun de voir le monde sous tous ses
            angles et de le ressentir différemment.
          </p>
        </div>
        {/* Sections biographiques en 3 colonnes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {/* Section 1 */}
          <div className={`bg-[#16161e] rounded-lg overflow-hidden shadow-lg border border-gray-700 transform transition-all duration-700 hover:shadow-2xl ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{transitionDelay: '1200ms'}}>
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-4 text-white">Passions</h3>
              <p className="text-gray-300 leading-relaxed">
                Les voyages sont une de mes passions ardentes. Grand rêveur, je
                désire explorer le monde sous toutes ses facettes. Chaque destination est une nouvelle source d'inspiration pour mes créations visuelles.
              </p>
            </div>
          </div>
          
          {/* Section 2 */}
          <div className={`bg-[#16161e] rounded-lg overflow-hidden shadow-lg border border-gray-700 transform transition-all duration-700 hover:shadow-2xl ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{transitionDelay: '1400ms'}}>
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-4 text-white">Parcours</h3>
              <p className="text-gray-300 leading-relaxed">
                Mon intérêt marqué pour les voitures m'a poussé à poursuivre des
                études en mécanique automobile. Cependant, c'est ma passion
                grandissante pour la photographie et la vidéographie qui a
                véritablement nourri mon côté créatif et artistique.
              </p>
            </div>
          </div>
          
          {/* Section 3 */}
          <div className={`bg-[#16161e] rounded-lg overflow-hidden shadow-lg border border-gray-700 transform transition-all duration-700 hover:shadow-2xl ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} style={{transitionDelay: '1600ms'}}>
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-4 text-white">Vision</h3>
              <p className="text-gray-300 leading-relaxed">
                Mon aspiration la plus profonde est de susciter des émotions et de
                faire vivre des aventures à travers mes créations. Je souhaite
                permettre aux autres de ressentir chaque émotion capturée.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-12 mb-20">
          <div className="bg-[#16161e] rounded-lg overflow-hidden shadow-xl border border-gray-700 max-w-4xl mx-auto">
            <div className="p-10">
              <div className="text-4xl text-gray-500 mb-4">“</div>
              <p className="text-gray-300 text-lg italic text-center leading-relaxed mb-4">
                Je laisse libre cours à mon enfant intérieur pour qu'il s'exprime à
                travers l'art visuel, inspirant les autres à percevoir le monde
                différemment, avec curiosité et passion. Chaque photographie et chaque
                vidéo que je crée est une invitation à explorer, à ressentir et à
                s'émerveiller devant la beauté et la diversité qui nous entourent.
              </p>
              <div className="text-4xl text-gray-500 text-right">”</div>
              <div className="w-16 h-1 bg-gray-500 mx-auto mt-6"></div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};